import { useEffect } from 'react';

// Mirrors every page's own IntersectionObserver script: reveals any .reveal
// element on the current page once it scrolls into view. Call once per page
// component, after its content has rendered — each page unmounts the last,
// so document.querySelectorAll always reflects only the current page's DOM.
export function useScrollReveal() {
  useEffect(() => {
    const targets = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('in'));
      return undefined;
    }
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('in'); obs.unobserve(entry.target); }
      }),
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    targets.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}
